import React from 'react';
import Loadable from 'react-loadable';
import { Switch } from 'react-router-dom';
import ConferenceWrapper from '@components/Conference/ConferenceWrapper';

import EditableRoute from '@components/EditableRoute';
import PageWrapper from '@modules/conferencing/components/PageWrapper';

const Loading = () => <div />;

const CurrentMeetings = Loadable({
  loader: () => import('@modules/conferencing/pages/CurrentMeetings'),
  loading: Loading,
});

const MeetingDetail = Loadable({
  loader: () => import('@modules/conferencing/pages/meeting'),
  loading: Loading,
});

const WaitingRoomConfiguration = Loadable({
  loader: () => import('@modules/conferencing/pages/WaitingRoomConfiguration'),
  loading: Loading,
});

const CheckInSearch = Loadable({
  loader: () => import('@modules/conferencing/pages/CheckInSearch'),
  loading: Loading,
});

const CheckInDetail = Loadable({
  loader: () => import('@modules/conferencing/pages/CheckInDetail'),
  loading: Loading,
});

const CheckInDetailInformal = Loadable({
  loader: () => import('@modules/conferencing/pages/CheckInDetail/informal'),
  loading: Loading,
});

const ConferencingConfiguration = Loadable({
  loader: () => import('@modules/conferencing/pages/ConferencingConfiguration'),
  loading: Loading,
})

export const prefix = '/conferencing';

export const appRoutes = {};

export const pathToTitleAndComponent = {
  [prefix]: {
    title: 'Current Meetings',
    component: CurrentMeetings,
  },
  [prefix + '/current-meetings']: {
    title: 'Current Meetings',
    component: CurrentMeetings,
  },
  [prefix + '/meeting']: {
    title: 'Conferencing',
    component: MeetingDetail,
  },
  [prefix + '/waiting-room-configuration']: {
    title: 'Waiting Room Configuration',
    component: WaitingRoomConfiguration,
  },
  [prefix + '/checkin-search']: {
    title: 'Check In Search',
    component: CheckInSearch,
  },
  [prefix + '/checkin-detail-formal/:roomID/:id']: {
    title: 'Check In Detail - Formal',
    component: CheckInDetail,
  },
  [prefix + '/checkin-detail-informal/:roomID/:id']: {
    title: 'Check In Detail - Informal',
    component: CheckInDetailInformal,
  },
  [prefix + '/conferencing-configuration']: {
    title: 'Conferencing Configuration',
    component: ConferencingConfiguration
  },
  ...appRoutes,
};

export const parseHeaderTitle = path => {
  const paths = Object.keys(pathToTitleAndComponent);
  const currentPath = paths.find(p => p !== prefix && path.startsWith(p)); // skip '/' route

  var route = pathToTitleAndComponent[currentPath];
  console.log('***************', path);
  if(!route) {
    return 'Conferencing';
  }
  return route.title;
};

const ConferencingRoutes = props => (
  <PageWrapper {...props}>
    <ConferenceWrapper prefix={prefix} {...props}>
      <Switch>
        {Object.entries(pathToTitleAndComponent).map(
          ([path, { component }]) => (
            <EditableRoute exact key={path} path={path} component={component} />
          ),
        )}
      </Switch>
    </ConferenceWrapper>
  </PageWrapper>
);

export default ConferencingRoutes;
